import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../Redux/Actions/AuthActions';
import './ProviderRegister.css'; // Re-use the provider styling theme
import logo from "../image/bookly_logo.png";

const ProviderLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(login({ email, password, targetRole: 'provider' }, navigate));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 provider-register-background">
      <div className="provider-register-container shadow rounded p-5 text-center">
        <img src={logo} alt="Bookly Logo" className="mb-4 provider-logo-img" />
        <h4 className="mb-3 text-secondary font-weight-bold">Espace Prestataire</h4>
        <p className="text-muted small mb-4">Connexion à votre espace d'administration de services</p>

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Adresse Email professionnelle</Form.Label>
            <Form.Control
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="contact@votre-spa.com"
              value={email}
              className="input-field"
              required
            />
          </Form.Group>

          <Form.Group className="mb-4 text-start">
            <Form.Label>Mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="••••••••"
              value={password}
              className="input-field"
              required
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100 btn-submit mb-3">
            Se connecter
          </Button>

          <div className="d-flex flex-column gap-2 mt-4 text-muted" style={{ fontSize: '13.5px' }}>
            <div className="d-flex justify-content-between">
              <span>Nouvel établissement ? <Link to="/ProviderRegister">S'inscrire</Link></span>
              <span><Link to="/Login" className="text-primary font-weight-bold">Accès Client ➔</Link></span>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ProviderLogin;
